var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.page.page_data['gjs-html'])}})])
}
var staticRenderFns = []

export { render, staticRenderFns }